import styled from "styled-components";
import { getSite } from "../utils/sites";
import { isSiteWithAd, PageAdData } from "../utils/adverts";
import { useSelector } from "react-redux";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { getPlaymakerUrl } from "../utils/playmaker";

const AdWrap = styled.div`
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${({ theme }) => theme.space[6]};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    width: 100%;
  }
`;

export const PageAdWrap = styled.div`
  margin: ${({ theme }) => theme.space[3]} 0;
`;

const PageAd = () => {
  const site = getSite();
  const player = useSelector(getPlayerData);
  if (!isSiteWithAd(site, PageAdData)) {
    return null;
  }

  // We don't have an element to send to the top banner ad, but the function expects it, so we send null. The function will then use the player data to determine the correct URL.
  const url = getPlaymakerUrl(player, "banner_top");
  const adData = PageAdData[site];

  return (
    <AdWrap>
      <a target="_blank" rel="noopener noreferrer" href={url}>
        <picture>
          <source media="(max-width: 400px)" srcSet={`${adData.srcSetSmall}`} />
          <source media="(min-width: 401px)" srcSet={`${adData.srcSetLarge}`} />
          <img
            src={adData.srcSetSmall}
            srcSet={`${adData.srcSetSmall} 400w, ${adData.srcSetLarge} 1200w`}
            sizes="(max-width: 400px) 100vw, 1200px"
            alt={adData.altText}
            width="100%"
          />
        </picture>
      </a>
    </AdWrap>
  );
};

export default PageAd;
